import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import K from "../../utilities/constants";
import { fetchBaseQueryObject } from "./fetchBaseQueryObject";
// Define a service using a base URL and expected endpoints
export const roomApi = createApi({
  reducerPath: "roomApi",
  baseQuery: fetchBaseQuery(fetchBaseQueryObject()),
  endpoints: (builder) => ({
    getRoomById: builder.query({
      query: (id) => `${K.Network.URL.publicRooms}/${id}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetRoomByIdQuery } = roomApi;
